import { render } from "./IconSearch.vue?vue&type=template&id=2a0423f7&scoped=true"
import script from "./IconSearch.vue?vue&type=script&lang=js"
export * from "./IconSearch.vue?vue&type=script&lang=js"

import "./IconSearch.vue?vue&type=style&index=0&id=2a0423f7&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0423f7"]])

export default __exports__